import { render } from "./sysconfig.vue?vue&type=template&id=1bd29751&scoped=true&ts=true"
import script from "./sysconfigHelper.ts?vue&type=script&lang=ts"
export * from "./sysconfigHelper.ts?vue&type=script&lang=ts"

import "./sysconfig.vue?vue&type=style&index=0&id=1bd29751&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd29751"]])

export default __exports__